// AdminDashboard.jsx (with "view desc" button)
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import AddProject from "./components/AddProject";
import EditProject from "./components/EditProject";
import "./AdminDashboard.css";

const TABS = [
  { key: "unassigned", label: "Unassigned Projects" },
  { key: "ongoing", label: "Ongoing Projects" },
  { key: "completed", label: "Completed Projects" },
  { key: "failed", label: "Failed Projects" },
];

const backgroundStyle = {
  background: "url('/background.png') center/cover no-repeat",
  minHeight: "100vh"
};

function AdminDashboard() {
  const [projects, setProjects] = useState({});
  const [editingProject, setEditingProject] = useState(null);
  const [updatedProject, setUpdatedProject] = useState({});
  const [selectedProject, setSelectedProject] = useState(null);
  const [bids, setBids] = useState([]);
  const [showAddProject, setShowAddProject] = useState(false);
  const [activeTab, setActiveTab] = useState("unassigned");
  const navigate = useNavigate();

  const fetchProjects = async () => {
    try {
      const response = await fetch("http://localhost:5002/admin/segregateProjects", {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setProjects(data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role !== "0") {
      alert("Unauthorized Access! Redirecting...");
      navigate("/login");
    }
    fetchProjects();
  }, [navigate]);

  const handleUpdate = async () => {
    if (!updatedProject.project_id) return;
    try {
      const response = await fetch(`http://localhost:5002/admin/updateproject/${updatedProject.project_id}`, {
        method: "PUT",
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedProject),
      });
      if (!response.ok) throw new Error(await response.text());
      setEditingProject(null);
      fetchProjects();
    } catch (error) {
      console.error("Update error:", error);
    }
  };

  const fetchBids = async (projectId) => {
    try {
      const response = await fetch(`http://localhost:5002/admin/viewbids/${projectId}`);
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const bidsData = await response.json();
      bidsData.sort((a, b) => parseFloat(a.bid_amount) - parseFloat(b.bid_amount));
      setBids(bidsData);
      setSelectedProject(projectId);
    } catch (error) {
      console.error("Fetch bids error:", error);
    }
  };

  const renderTabs = () => (
    <div className="tabs">
      {TABS.map(({ key, label }) => (
        <button
          key={key}
          className={`tab-btn ${activeTab === key ? "active" : ""}`}
          onClick={() => setActiveTab(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );

  const renderProjectTable = (title, projectsList) => (
    <div>
      <h3>{title}</h3>
      <table>
        <thead>
          <tr>
            <th>Project Name</th>
            <th>Actions</th>
            {title === ("Ongoing Projects" && "Completed Projects") && <th>Assigned To</th>}
            {title === "Ongoing Projects" && <th>Contact</th>}
          </tr>
        </thead>
        <tbody>
          {projectsList?.length > 0 ? (
            projectsList.map((project, index) => (
              <tr key={project.project_id}>
                <td>{project.project_title || "N/A"}</td>
                <td>
                  <button
                    className="desc-btn"
                    onClick={() => navigate(`/admin/project/${project.project_id}`)}
                  >
                    view desc
                  </button>
                </td>
                {title === ("Ongoing Projects" && "Completed Projects") && <td>{project.assigned_to_name || "N/A"}</td>}
                {title === "Ongoing Projects" && (
                  <td>
                    {project.assigned_to_email ? (
                      <a href={`mailto:${project.assigned_to_email}`}>Contact</a>
                    ) : (
                      "No Email"
                    )}
                  </td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12">No projects available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="admin-dashboard" style={backgroundStyle}>
      <h2>Admin Dashboard</h2>

      <button className="add-project-btn" onClick={() => setShowAddProject(!showAddProject)}>
        {showAddProject ? "Close Form" : "Add New Project"}
      </button>

      {showAddProject && (
        <AddProject
          onProjectAdded={() => {
            setShowAddProject(false);
            fetchProjects();
          }}
        />
      )}

      {renderTabs()}
      {activeTab === "unassigned" && renderProjectTable("Unassigned Projects", projects.unassignedProjects)}
      {activeTab === "ongoing" && renderProjectTable("Ongoing Projects", projects.ongoingProjects)}
      {activeTab === "completed" && renderProjectTable("Completed Projects", projects.completedProjects)}
      {activeTab === "failed" && renderProjectTable("Failed Projects", projects.failedProjects)}

      {editingProject && (
        <EditProject
          project={updatedProject}
          onChange={setUpdatedProject}
          onUpdate={handleUpdate}
          onCancel={() => setEditingProject(null)}
        />
      )}
    </div>
  );
}

export default AdminDashboard;
